function getPermissions() {
  try {
    return localStorage.permissions ? JSON.parse(localStorage.permissions) : {};
  } catch (error) {
    return {};
  }
}

export function isAdminUser() {
  const permissions = getPermissions();
  return (
    localStorage?.is_superadmin === "true" ||
    permissions?.is_superuser === true
  );
}

export function isStaffUser() {
  if (isAdminUser()) {
    return false;
  }

  if (localStorage?.is_staff === "true") {
    return true;
  }

  return localStorage?.is_freelance !== "true";
}

function hasPermission(permission) {
  const permissions = getPermissions();
  return isAdminUser() || Boolean(permissions?.[permission]);
}

export function isFreelanceUser() {
  return (
    !isAdminUser() &&
    !isStaffUser() &&
    localStorage?.is_freelance === "true"
  );
}

export function canFreelanceViewArchivedFiles() {
  return hasPermission("can_view_archive_files");
}

export function canFreelanceCommentFiles() {
  return hasPermission("can_comment_files");
}

export function canFreelanceViewCustomers() {
  return false;
}

export function isFreelanceRouteAllowed(pathname) {
  if (!isFreelanceUser()) {
    return true;
  }

  const allowedRoutes = ["/Expedientes", "/Expediente"];

  if (canFreelanceViewArchivedFiles()) {
    allowedRoutes.push("/Archivados", "/ExpedienteArchivado");
  }

  return allowedRoutes.some(
    (route) => pathname === route || pathname.startsWith(`${route}/`)
  );
}
